module.exports = __webpack_public_path__ + "assets/img/btn-back-c2cd0d32.png";